import { Fragment, useContext, useEffect, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import { Alert, NotificationManager, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";
import SubNavigation from "../../components/Header/SubNavigation";
import AuthModuleConfigurationTable from "../../components/Tables/AuthModuleConfigurationTable";
import AuthModuleConfigurationModal from "../../components/Modals/AuthModuleConfigurationModal";
import ConfirmModal from "../../components/Modals/ConfirmModal";
import { isAuthModuleAllowedHandler, notifyUser } from "../../services/helpers";

const AuthModuleConfiguration = () => {
  const [clients, setClients] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editableClient, setEditableClient] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    getStagedFlowConfigurations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientFiscalCode]);

  const getStagedFlowConfigurations = () => {
    setIsLoading(true);
    sendApiRequest(
      "StagedFlowConfiguration/GetStagedFlowConfigurations",
      "GET",
      true,
      { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
      signIn,
      signOut,
      navigate,
      createQueryString,
      userContext,
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setClients(response.data.stagedFlowConfigurations);
          setIsLoading(false);
        }
      }
    });
  };

  const modalOpenHandler = (client) => {
    setModalOpen(true);
    setEditableClient(client);
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
    getStagedFlowConfigurations();
    isAuthModuleAllowedHandler(
      userContext.selectedClientFiscalCode,
      signIn,
      signOut,
      navigate,
      userContext,
      setError,
    );
  };

  const confirmModalOpenHandler = (client) => {
    setEditableClient(client);
    setTimeout(() => {
      document.querySelector(".modal-email").textContent =
        client.clientCodeName;
    }, 200);
    setConfirmModalOpen(true);
  };

  const confirmModalCloseHandler = () => {
    setConfirmModalOpen(false);
  };

  return (
    <Fragment>
      <SubNavigation page="authModuleConfiguration" />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <AuthModuleConfigurationTable
            items={clients}
            columns={[
              {
                name: "Tipologia Servizio",
                type: "string",
                sortable: true,
                value: "clientCodeName",
              },
              {
                name: "Codice Tipologia Servizio",
                type: "string",
                sortable: true,
                value: "clientCode",
              },
              {
                name: "Formato",
                type: "string",
                sortable: false,
                value: "format",
              },
              {
                name: "Autorizzazione Tecnica",
                type: "string",
                sortable: false,
                value: "isActiveTech",
              },
              {
                name: "Autorizzazione Finanziaria",
                type: "string",
                sortable: false,
                value: "isActiveEcon",
              },
              {
                name: "Giorni di Permanenza Documenti",
                type: "integer",
                sortable: false,
                value: "documentsAvailabilityDays",
              },
              {
                name: "Coeff. Moltiplicativo (costo piattaforma)",
                type: "integer",
                sortable: false,
                value: "digitalCoefficient",
              },
              {
                name: "Coeff. Moltiplicativo (costi notifiche analogiche)",
                type: "integer",
                sortable: false,
                value: "analogicalCoefficient",
              },
              {
                name: "Stato",
                type: "string",
                sortable: false,
                value: "isActive",
              },
              {
                name: "Azioni",
                type: "",
                sortable: false,
                value: "",
              },
            ]}
            openModalHandler={modalOpenHandler}
            confirmModalOpenHandler={confirmModalOpenHandler}
            getStagedFlowConfigurations={getStagedFlowConfigurations}
          />
        )}
      </Section>
      <AuthModuleConfigurationModal
        modalOpen={modalOpen}
        modalCloseHandler={modalCloseHandler}
        selectedClient={editableClient}
      />
      <ConfirmModal
        confirmModalOpen={confirmModalOpen}
        confirmModalCloseHandler={confirmModalCloseHandler}
        notifyUser={notifyUser}
        clientId={editableClient.clientId}
        setExtFlowConfigs={setClients}
        method={"deleteStagedFlowConfigurationHandler"}
        text={
          "Stai per eliminare la configurazione dei modulo autorizzativo per la tipologia servizio selezionata"
        }
      />
      <Footer />
      <div>
        <NotificationManager
          containerId="esempio-avanzato"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
    </Fragment>
  );
};

export default AuthModuleConfiguration;
